import Layout from '../../internal/Layout.vue'
import SyntheticDashboardPage from './index.vue'

const SyntheticDashboardRoutes = {
  component: Layout,
  children: [
    {
      name: 'syntheticDashboard',
      path: '/',
      component: SyntheticDashboardPage,
      meta: {
        module: 'relatorios_dashboard_sintetica',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: false,
        requiresLaboratory: false,
      },
    },
  ],
}

export default SyntheticDashboardRoutes
